<template>
    <div class="text-center">
       <div class="invoice-status success bold-span p-3" v-b-tooltip :title="data.formattedStatus" :class="[data.sentStatus === 'Not sent' ? 'danger' : data.sentStatus === 'No transaction' ? 'success' : data.sentStatus === 'Sent' ? 'paidColor' : 'yelloInvoiceColor']">
            {{data.sentStatus}}
       </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            data: {}
        }
    }
 }
</script>